module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }